import {
  AccordionSummary as MUIAccordionSummary,
  AccordionSummaryProps as MUIAccordionSummaryProps,
} from "@mui/material";
import * as React from "react";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

type AccordionSummaryProps = MUIAccordionSummaryProps & {};
const AccordionSummary = (props: AccordionSummaryProps) => {
  const { expandIcon, ...other } = props;
  return (
    <MUIAccordionSummary
      {...other}
      expandIcon={expandIcon ?? <ExpandMoreIcon />}
    >
      {props.children}
    </MUIAccordionSummary>
  );
};

export default AccordionSummary;
